export type NotificationSnapshotPayload = {
  event_id: string;
  type: 'notifications.snapshot';
  unread_count: number;
};

export function normalizePayload(data: unknown): unknown {
  if (typeof data !== 'string') return data;
  return parseJsonOrString(data);
}

export function parseJsonOrString(value: string): unknown {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export function isSnapshotPayload(
  value: unknown,
): value is NotificationSnapshotPayload {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<NotificationSnapshotPayload>;

  return (
    candidate.type === 'notifications.snapshot' &&
    typeof candidate.unread_count === 'number'
  );
}
